import React, { useState } from 'react';
import './Map.css';
import { Container } from 'react-bootstrap';
import {Title} from '../../../../Components'
import map from '../../../../assets/Images/home/world-map-1.png'; // World map image
import flag1 from '../../../../assets/Images/svg/twemoji_flag-saudi-arabia.svg';
import flag2 from '../../../../assets/Images/svg/emojione-v1_flag-for-united-arab-emirates.svg';

// Static data for countries, including flags
const countryData = [
  { name: "Saudi Arabia", flag:flag1, top: "38%", left: "57%" },
  { name: "United Arab Emirates", flag: flag2, top: "42%", left: "59%" },
  // Add more countries and flag paths here
];    

const Map = ({url, section}) => {

  const { map_image } = section.data;

  const [selectedCountry, setSelectedCountry] = useState(null);

  const handlePointClick = (country) => {
    setSelectedCountry(country);
  };

  return (
    <div className="map-container">
      <Container>
        <Title title={"Our Worldwide Presence"} overlay={"Map"} />
      </Container>
      <div className="map"> 
        <img src={url+"/"+ map_image} alt="World Map" className='world-map' />
        {countryData.map((country, index) => (
          <div
            key={index}
            className="map-point radar_animation"
            style={{
              top: country.top,
              left: country.left,
            }}
            onClick={() => handlePointClick(country)}
          >
            <span></span>
            <span></span>
            <span></span>
            {/* <span className="map-point-indicator"></span> */}
          </div>
        ))}
      </div>

      {selectedCountry && (
        <div
          className="country-info"
          style={{
            top: `calc(${selectedCountry.top} - 20px)`,
            left: `calc(${selectedCountry.left} - 35px)`,
          }}
        >
          <div className="tooltip-arrow"></div>
          <img src={selectedCountry.flag} className='flag-icon'/>
          <h3>{selectedCountry.name}</h3>
        </div>
      )}
    </div>
  );
};

export default Map;
